import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Pencil } from "lucide-react";

interface ProfileBioProps {
  bio: string | null;
  isEditing: boolean;
  isOwnProfile: boolean;
  editedBio: string;
  onEdit: () => void;
  onChange: (value: string) => void;
  onSave: () => void;
}

export const ProfileBio = ({
  bio,
  isEditing,
  isOwnProfile,
  editedBio,
  onEdit,
  onChange,
  onSave,
}: ProfileBioProps) => {
  return (
    <div className="bg-flux-black/50 border border-flux-cyan/20 rounded-lg p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-flux-cyan text-xl">Bio</h2>
        {isOwnProfile && !isEditing && (
          <Button
            size="icon"
            variant="ghost"
            onClick={onEdit}
            className="text-flux-purple hover:text-flux-purple/80"
          >
            <Pencil className="h-4 w-4" />
          </Button>
        )}
      </div>
      {isEditing ? (
        <div className="space-y-2">
          <Textarea
            value={editedBio}
            onChange={(e) => onChange(e.target.value)}
            className="bg-transparent border-flux-cyan/20 min-h-[100px]"
            placeholder="Tell us about yourself..."
          />
          <Button
            onClick={onSave}
            className="text-flux-purple hover:text-flux-purple/80"
          >
            Save
          </Button>
        </div>
      ) : (
        <p className="text-gray-300">{bio || "No bio yet"}</p>
      )}
    </div>
  );
};